export enum OwnerType {
  None = 0,
  AARVLTEAO = 1,
  PGSUSCEOO = 2,
  PGSUSNEOO = 3,
  PEGASUSO = 4,
  THYTECO = 5,
  TTMS = 6,
  AARFLYDB = 7,
  SSM = 8,
}
export const OwnerTypeDesc = [
  { Description: "None", Value: OwnerType.None },
  { Description: "AARVLTEA-O", Value: OwnerType.AARVLTEAO },
  { Description: "PGSUSCEO-O", Value: OwnerType.PGSUSCEOO },
  { Description: "PGSUSNEO-O", Value: OwnerType.PGSUSNEOO },
  { Description: "PEGASUS-O", Value: OwnerType.PEGASUSO },
  { Description: "THYTEC-O", Value: OwnerType.THYTECO },
  { Description: "TTMS-O", Value: OwnerType.TTMS },
  { Description: "SSM-KKU-O", Value: OwnerType.SSM },
  { Description: "AARFLYDB-O", Value: OwnerType.AARFLYDB },
];
